import { Box, Button, Stack, Typography } from '@mui/material';

import { defaultLeadNextStepStatuses } from '@/root/defaultConfiguration';
import type { LeadNextStep, LeadNextStepStatus } from '@/types';

export const LeadNextStepsStatusList = ({
    steps,
    onStatus,
    disabled,
}: {
    steps: LeadNextStep[] | undefined;
    onStatus?: (stepId: number, status: LeadNextStepStatus) => void;
    disabled?: boolean;
}) => {
    const ordered = [...(steps || [])].sort(
        (a, b) => (a.position ?? 0) - (b.position ?? 0)
    );
    if (ordered.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                No next steps
            </Typography>
        );
    }
    return (
        <Stack spacing={1.5}>
            {ordered.map(step => (
                <Box
                    key={step.id ?? step.name}
                    sx={{ p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}
                >
                    <Typography variant="body2">{step.name}</Typography>
                    <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
                        {defaultLeadNextStepStatuses.map(item => (
                            <Button
                                key={item.value}
                                size="small"
                                variant={
                                    step.status === item.value ? 'contained' : 'outlined'
                                }
                                disabled={disabled || step.id == null || !onStatus}
                                onClick={() =>
                                    step.id != null &&
                                    onStatus?.(Number(step.id), item.value as LeadNextStepStatus)
                                }
                            >
                                {item.label}
                            </Button>
                        ))}
                    </Stack>
                </Box>
            ))}
        </Stack>
    );
};
